import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CaracteristicasEntidadBenefDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CaracteristicasEntidadBenefService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCaracteristicasEntidadBenefPorEntidadService(codigo:string): Observable<BodyListResponse<CaracteristicasEntidadBenefDTO>> {
    return this.http.get<BodyListResponse<CaracteristicasEntidadBenefDTO>>(API_URL + '/api/v1/caracteristicasEntidadBenef/entidad/'+codigo);
  }

  getCaracteristicasEntidadBenefService(): Observable<BodyListResponse<CaracteristicasEntidadBenefDTO>> {
    return this.http.get<BodyListResponse<CaracteristicasEntidadBenefDTO>>(API_URL + '/api/v1/caracteristicasEntidadBenef/todos');
  }

  guardarCaracteristicasEntidadBenefService(caracteristicasEntidadBenefDTO: CaracteristicasEntidadBenefDTO): Observable<BodyResponse<CaracteristicasEntidadBenefDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/caracteristicasEntidadBenef', caracteristicasEntidadBenefDTO);
  }

  getCaracteristicasEntidadBenefPorCodigoService(codigo: string): Observable<BodyResponse<CaracteristicasEntidadBenefDTO>> {
    return this.http.get<BodyResponse<CaracteristicasEntidadBenefDTO>>(API_URL + '/api/v1/caracteristicasEntidadBenef/' + codigo);
  }
}
